<template>
  <div>
    <v-card
      :color="done ? 'success' : 'default'"
      outlined
      hover
      @click="openDetail"
      style="margin:5px;"
    >
      <v-card-title :class="{allWhite: done}">{{ name }}</v-card-title>
      <v-card-text :class="{allWhite: done}">
        <p>{{ description.substr(0, 60) + "..." }}</p>
        <p>
          <b>{{ $t("taskcard.next_execution") }}:</b>
          {{ next_time === 0 ? '...' : parseDateTime(next_time) }}
        </p>
        <v-progress-linear
          :color="done ? 'default' : 'primary'"
          :value="nextExecutionProgress"
          :indeterminate="!l_last_done"
        ></v-progress-linear>
      </v-card-text>
      <!--<v-card-actions right>
        <v-btn :color="done ? 'white' : 'primary'" @click="markAsDone" text>Mark as done</v-btn>
      </v-card-actions>-->
    </v-card>
  </div>
</template>

<script>
import intervals from "../assets/data/intervals.js";
import { storage, s_messaging } from "../schmucklicloud";
import { Notifications } from "../notification";

export default {
  props: {
    id: Number,
    name: String,
    description: String,
    interval: Number
  },
  mounted() {
    this.getNextExecution();
  },
  data() {
    return {
      dialog: false,
      dialog_history: false,

      l_last_done: false,

      intervals: intervals,

      history: [],

      current_time: 0,
      next_time: 0,
      last_time: 0,

      edit_name: this.name,
      edit_description: this.description,
      edit_interval: this.interval,

      timer_current_time: undefined
    };
  },
  computed: {
    done() {
      return this.nextExecutionProgress >= 100 && this.l_last_done;
    },
    nextExecutionProgress() {
      var q = Math.abs(this.current_time - this.last_time);
      var d = Math.abs(this.next_time - this.last_time);

      return (q / d) * 100;
    }
  },
  methods: {
    openDetail() {
      this.$router.push("/task/" + this.id);
    },
    async getNextExecution() {
      this.current_time = new Date().getTime();
      this.last_time = parseInt((await this.getLastDone()).data.time);
      this.next_time = this.last_time + this.interval * 1000;

      if (!this.done) {
        this.$emit("putOnBottom");
      }

      clearInterval(this.timer_current_time);
      this.timer_current_time = setInterval(
        function() {
          this.current_time = new Date().getTime();
        }.bind(this),
        2 * 1000
      );
    },
    async markAsDone(e) {
      e.stopPropagation();
      var response = await storage.insert("dones", {
        task_id: this.id,
        time: new Date().getTime()
      });

      if (response.isOK) {
        Notifications.show("The task has now been marked as done.");
        await this.getNextExecution();
        s_messaging.sendRequestLater(
          JSON.stringify({
            notification: {
              title: this.name,
              description: this.description
            },
            task: {
              id: this.id
            }
          }),
          Math.round(this.next_time / 1000)
        );
      } else {
        Notifications.show(response.message);
      }
    },
    async getLastDone() {
      var response = await storage.get(
        "dones",
        [
          {
            column: "task_id",
            operator: "==",
            value: this.id
          }
        ],
        {
          column: "time",
          order: "desc"
        }
      );

      this.l_last_done = true;

      if (response.isOK) {
        return response.data[0];
      } else {
        Notifications.show(
          "There was an error while trying to get the last execution."
        );
      }
    },
    parseDateTime(time) {
      var date = new Date();
      date.setTime(time);
      return (
        (date.getDate() + "").padStart(2, "0") +
        "." +
        (date.getMonth() + 1 + "").padStart(2, "0") +
        "." +
        date.getFullYear() +
        " " +
        (date.getHours() + "").padStart(2, "0") +
        ":" +
        (date.getMinutes() + "").padStart(2, "0")
      );
    }
  }
};
</script>

<style>
.allWhite {
  color: white;
}
</style>